import { useEffect } from 'react';

import { useError } from '@client/hooks/useError';
import { useRevenueQueries } from '@client/queries/useRevenueQueries';
import { useLoading } from '@client/store/loading.store';

export const useRevenue = () => {
  const { useBalance, useLedger } = useRevenueQueries();
  const { setError: _setError } = useError();

  const {
    data: wallet,
    isLoading: balanceLoading,
    isFetching: balanceFetching,
    refetch: refetchBalance,
  } = useBalance();

  const {
    data: ledgerData,
    isLoading: ledgerLoading,
    isFetching: ledgerFetching,
    refetch: refetchLedger,
  } = useLedger();

  const { loading, setLoading } = useLoading(false);

  const isQueryLoading =
    balanceLoading || balanceFetching || ledgerLoading || ledgerFetching;
  useEffect(() => {
    setLoading(isQueryLoading);
  }, [isQueryLoading, setLoading]);

  const refetch = async (): Promise<void> => {
    await Promise.all([refetchBalance(), refetchLedger()]);
  };

  return {
    loading,
    wallet,
    entries: ledgerData?.entries ?? [],
    total: ledgerData?.total ?? 0,
    refetch,
  };
};
